var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.419a7.693 7.693 0 01-2.126.583 3.67 3.67 0 001.623-2.04c-.713.425-1.5.726-2.34.893a3.689 3.689 0 00-6.383 2.523c0 .293.025.574.085.842a10.445 10.445 0 01-7.606-3.86 3.715 3.715 0 00-.505 1.865c0 1.278.658 2.411 1.64 3.067A3.644 3.644 0 01.72 5.838v.04a3.707 3.707 0 002.957 3.626c-.3.082-.628.122-.968.122a3.3 3.3 0 01-.699-.063 3.725 3.725 0 003.449 2.57 7.414 7.414 0 01-4.576 1.574c-.302 0-.593-.013-.883-.05a10.389 10.389 0 005.661 1.655c6.79 0 10.503-5.624 10.503-10.5 0-.163-.006-.32-.014-.477A7.362 7.362 0 0018 2.419z",
    fill: "#489DFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b7c168ddb2616139e911571dec38e9bf.svg";
export { ForwardRef as ReactComponent };